import { commonfunc } from '@/mixin/common'
import spbkMixin from '@/mixin/or/spbkMixin'

const pdMixin = {
  mixins: [commonfunc, spbkMixin],
  data () {
    return {
      mbEid: this.$store.getters['session/getMbEid'], // 회원id
      mbMngNo: this.$store.getters['session/getMbMngNo'], // 회원관리번호
      baseUrl: process.env.VUE_APP_ENV === 'loc' ? 'https://stgc.daisomall.co.kr' : process.env.CDN_BASE_URL,
    }
  },
  computed: {
    isLogin () {
      return this.isNotEmpty(this.mbMngNo)
    }
  },
  mounted () {
  },
  unmounted () {
    const scrollAreaEl = window
    scrollAreaEl.removeEventListener('scroll')
  },
  methods: {
    // replace image url
    replaceImg (url) {
      return this.isNotEmpty(url) ? this.baseUrl + url.substring(url.indexOf('/file')) : '' // /images/tempLy/noimage.png
    },
    // replace error image
    errorImg (e) {
      // e.target.src = '/images/tempLy/noimage.png'
      e.target.style.display = 'none'
    },
    // replace profile image url
    replacePrfImg (url) {
      return this.isNotEmpty(url) ? this.baseUrl + url.substring(url.indexOf('/file')) : '/images/icon/profile_noimg.png'
    },
    // replace error profile image
    errorPrfImg (e) {
      e.target.src = '/images/icon/profile_noimg.png'
    },

    // 최대값 표기
    maxNum (obj) {
      const num = typeof obj === 'number' ? obj : Number(obj)
      if (num > 999999) {
        return '99.9+만'
      } else if (num > 9999) {
        return String(Math.floor(num / 1000) / 10) + '만'
        // 10,000
      } else {
        return String(this.numberComma(num))
      }
    },

    pdApi (pdNo) {
      // 상품 api 리스트 셋팅
      return [
        { // 상품상세 내용, md공지, tqc공지
          name: 'pdDesc',
          url: '/pd/pdr/pdDtl/selPdDtlDesc',
          param: { pdNo }
        },
        { // 상품상세 고시정보
          name: 'pdNtfc',
          url: '/pd/pdr/pdDtl/selPdDtlNtfc',
          param: { pdNo }
        },
        { // 상품상세 리뷰 정리(속성정보 포함)
          name: 'pdRevwSmry',
          url: '/pd/pds/revw/selRevwSmry',
          param: { pdNo }
        },
        { // 상단 배너
          name: 'topBanr',
          url: '/ds/exh/selBanr',
          param: { exhCmptmtId: '2023082101', exhMtrlNo: '1', exhCtgrNo: '' }
        },
        { // 중간 배너
          name: 'midBanr',
          url: '/ds/exh/selBanr',
          param: { exhCmptmtId: '2023082102', exhMtrlNo: '1', exhCtgrNo: '' }
        },
        { // 택배배송, 정기배송, 오늘배송, 대량배송
          name: ['pdsDlvcPlcy', 'fdrmDlvcPlcy', 'quickDlvcPlcy', 'massDlvcPlcy'],
          url: '/dl/dlp-api/selDlvcPlcyInfo',
          param: { dlvcPlcyRqstList: [{ dlvcPlcyCd: 'DLVC000001', dlvFomCd: '01', orTyCd: '01' }, { dlvFomCd: '01', orTyCd: '02' }, { dlvcPlcyCd: 'DLVC000005' }, { dlvcPlcyCd: 'DLVC000003' }, { dlvcPlcyCd: 'DLVC000004' }] }
        },
        // { // 정기배송정책
        //   name: 'fdrmDlvcPlcy',
        //   url: '/dl/dlp-api/selDlvcPlcyInfo',
        //   param: { dlvcPlcyRqstList: [{ dlvFomCd: '01', orTyCd: '02' }] }
        // },
        // { // 오늘배송정책
        //   name: 'quickDlvcPlcy',
        //   url: '/dl/dlp-api/selDlvcPlcyInfo',
        //   param: { dlvcPlcyRqstList: [{ dlvcPlcyCd: 'DLVC000005' }] }
        // },
        // { // 대량배송정책
        //   name: 'massDlvcPlcy',
        //   url: '/dl/dlp-api/selDlvcPlcyInfo',
        //   param: { dlvcPlcyRqstList: [{ dlvcPlcyCd: 'DLVC000003' }, { dlvcPlcyCd: 'DLVC000004' }] }
        // },
        { // 픽업수수료
          name: 'pkupPlcy',
          url: '/dl/dlp-api/selPickupPlcyInfo',
          param: {}
        }
      ]
    },
    pdEvApi () {
      // 상품 혜택관련 api 리스트 셋팅
      return [
        { name: 'bnfInfo', url: '/ev/evf/selCustBnfInfo' }, // 혜택정보
        { name: 'cpnInfo', url: '/ev/evb/selPdDwldPsbCpnList' } // 쿠폰정보
      ]
    },

    // 토스트 팝업
    openToast (msg) {
      this.$notify({
        // title: 'Custom Position',
        message: msg,
        position: 'center',
        showClose: false,
        duration: 3000,
        dangerouslyUseHTMLString: true,
        onClick: () => { this.$notify.closeAll() }
      })
    },

    // 호출하는 페이지가 상품상세 내에 같은상품이면 리로드만
    moveRoutePdDtlPage (query) {
      if (this.$route.path === '/pd/pdr/SCR_PDR_0001' && this.$route.query.pdNo === query.pdNo) {
        this.$router.go(this.$router.currentRoute)
      } else {
        this.$router.push({ path: '/pd/pdr/SCR_PDR_0001', query })
      }
    },

    // 숫자 표기(만, 억단위로 표시하고 백의 자리에서 반올림)
    displayformatNumber (num) {
      if (num === null) {
        return '0'
      }

      if (typeof num === 'string') {
        num = Number(num)
      }

      if (num < 10000) {
        return num.toLocaleString('ko-KR')
      }

      let str = ''

      // 반올림하여 억/만으로 표시하여 리턴

      if (num < 1000000) {
        let mok = num / 10000
        console.log(mok)
        mok = Math.round(mok * 10) / 10
        console.log(mok)
        str = String(mok) + '만'
      } else {
        str = '99.9+만'
        // let mok = num / 100000000
        // mok = Math.round(mok * 10) / 10
        // str = String(mok) + '억'
      }

      return str
    },
  }
}

export { pdMixin }
